<div class="navbar-header">

    <div class="logo">
      <ng-container *ngIf="typeUser == 'admin' || typeUser == 'tenant' || typeUser == 'marketing'">
        <img class="logo-icon" src="assets/images/logos/logo_menu_tenant.png">
        <img class="logo-text" src="assets/images/logos/logo_menu_tenant.png">
      </ng-container>
      <ng-container *ngIf="typeUser == 'owner' || typeUser == 'both'">
        <img class="logo-icon" src="assets/images/logos/logo_menu_owner.png">
        <img class="logo-text" src="assets/images/logos/logo_menu_owner.png">
      </ng-container>
      
    </div>
  
</div>
  
<div class="navbar-content" appPerfectScrollbar>
    <app-navigation layout="vertical"></app-navigation>
</div>
  
  